export const environment = {
  production: false,
  apiUrl: 'https://api.waddle.imoks.dev',
  clerkPublishableKey: 'pk_test_ZnVuLXN0aW5rYnVnLTQ0LmNsZXJrLmFjY291bnRzLmRldiQ',
  mapboxToken: 'pk.eyJ1Ijoid2FkZGxlZGV2IiwiYSI6ImNtbDdiYXJjYzBrcDczZ3F4YzR0ZG40eDAifQ.D1T9mnRaJeayms1EE1qdIw',
  buildNumber: '4916',
  enableConsoleLogging: true,
  uploadDebug: true,
  uploadChunkingEnabled: true,
  uploadChunkSizeBytes: 5 * 1024 * 1024, // 5MB chunks
  // Google Analytics (staging → uses the first stream)
  gaEnabled: true,
  gaMeasurementId: 'G-CF5K5KWRF8'
};
